import { render, staticRenderFns } from "./AdvanceExpense.vue?vue&type=template&id=4fe61e47"
import script from "./AdvanceExpense.js?vue&type=script&lang=js&external"
export * from "./AdvanceExpense.js?vue&type=script&lang=js&external"
import style0 from "./AdvanceExpense.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports